import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e0a92a42"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e0a92a42')) {
      api.createRecord('e0a92a42', component.options)
    } else {
      api.reload('e0a92a42', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=e0a92a42", function () {
      api.rerender('e0a92a42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BjForm/index.vue"
export default component.exports